import { Desktop, Mobile } from '../../Common/const';

function ReferAFriendHeader() {
  return (
    <div>
      <Desktop>
        <div className="resources-header-container pt-5 pl-4 pb-5">
          Refer A Friend
        </div>
        <div className="gradient-divider" />
      </Desktop>
      <Mobile>
        <div className="resources-header-container pt-3 pl-2 pb-3">
          Refer A Friend
        </div>
        <div className="gradient-divider" />
      </Mobile>
    </div>
  );
}

export default ReferAFriendHeader;
